import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 11V11.6132C6 11.9369 6 12.0988 6.04575 12.2448C6.08624 12.374 6.15256 12.4936 6.24069 12.5965C6.34025 12.7127 6.4775 12.7984 6.752 12.97L7.75339 13.5959M18 11V11.6132C18 11.9369 18 12.0988 17.9542 12.2448C17.9138 12.374 17.8474 12.4936 17.7593 12.5965C17.6597 12.7127 17.5225 12.7984 17.248 12.97L16.2466 13.5959M7.75339 13.5959C8.32199 12.0794 9.78495 11 11.5 11H12.5C14.2151 11 15.678 12.0794 16.2466 13.5959M7.75339 13.5959L8.85714 14.2857M16.2466 13.5959L15.1429 14.2857M8 18V16.2361C8 16.0808 8.03614 15.9277 8.10557 15.7889L8.85714 14.2857M16 18V16.2361C16 16.0808 15.9639 15.9277 15.8944 15.7889L15.1429 14.2857M15.1429 14.2857L14.3891 14.7568C14.2444 14.8473 14.172 14.8925 14.0943 14.9245C14.0254 14.9529 13.9535 14.9736 13.88 14.986C13.7972 15 13.7118 15 13.5411 15H10.4589C10.2882 15 10.2028 15 10.12 14.986C10.0465 14.9736 9.9746 14.9529 9.90567 14.9245C9.82802 14.8925 9.75564 14.8473 9.61088 14.7568L8.85714 14.2857M2 8H10M14 8H22M6 8V6M18 8V6",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDrone;
